import parseDate from "./date";

const parseCreditCard = (card) =>
  `${card.card_brand?.toUpperCase()} ${card.last4} (${card.expiration_month}/${
    card.expiration_year
  })`;

const parsePayments = (payments) =>
  payments.flatMap((p) => {
    const output = [];
    const filteredStatuses = ["canceled"];
    if (filteredStatuses.includes(p.status)) return output;
    if (p.payment_method) {
      if (p.status === "failed" || p.status === "abandoned") {
        output.push({
          ...p,
          cardInfo: parseCreditCard(p.payment_method),
          totalAmount: p.amount,
          labelColor: "error",
        });
      } else {
        output.push({ ...p, cardInfo: parseCreditCard(p.payment_method), totalAmount: p.amount });
      }
      return output;
    }
    if (p.bonus_amount) {
      output.push({
        ...p,
        label: "WalletBonus",
        totalAmount: p.bonus_amount,
      });
    }
    if (p.amount && p.reference_type !== "TRIP_PAYMENT_DEBT") {
      output.push({
        ...p,
        label: "WalletReal",
        totalAmount: p.amount,
      });
    }
    return output;
  });

export default (receipt) => {
  if (!receipt) return receipt;
  const exchangeRate = receipt.exchange_rate?.rate?.rate || 1;
  // local currency * exchangeRate = wallet currency
  // wallet currency  / exchangeRate = local currency

  const passDeduction = receipt.pass_deduction || 0; // local currency
  const passDeductionWallet = Math.round(passDeduction * exchangeRate);
  const payments = parsePayments(receipt.payments || []); // wallet currency
  const chargedWallet = payments.reduce((acc, p) => acc + p.totalAmount, 0) + passDeductionWallet;

  return {
    ...receipt,
    trip_date: parseDate(receipt.trip_date),
    payments,
    passDeductionWallet,
    passDeductionMinutes: passDeduction
      ? (passDeduction - receipt.rate_plan?.flat_fee) / receipt.rate_plan?.time_unit_fee
      : 0,
    baseFare:
      receipt.fee_type === "time"
        ? Math.round((receipt.duration / 60) * receipt.rate_plan?.time_unit_fee)
        : Math.round(receipt.rate_plan?.distance_unit_fee * receipt.distance),
    printSubtotal: receipt.subtotal,
    fareTotalLocal: receipt.total_amount,
    fareTotalWallet: Math.round(receipt.total_amount * exchangeRate),
    chargedWallet,
    chargedLocal: Math.round(chargedWallet / exchangeRate),
    beforeWalletBalance: receipt.before_balance + receipt.before_bonus_balance,
    afterWalletBalance: receipt.after_balance + receipt.after_bonus_balance,
    currencyWallet: receipt.exchange_rate?.rate?.target || receipt.rate_plan?.currency,
    currencyLocal: receipt.rate_plan?.currency,
    balanceOutstanding: Math.round(
      Math.abs(
        receipt.total_amount - receipt.amount / exchangeRate - receipt.bonus_amount / exchangeRate,
      ),
    ),
    parkingIncentiveBonusWallet: receipt.parking_incentive_bonus,
    parkingIncentiveBonusLocal: Math.round(receipt.parking_incentive_bonus / exchangeRate),
  };
};
